import React from 'react';
import { ImageProps, Image } from '../../../wag-react/next-components/image';
export type ArticleCoverPhotoProps = ImageProps & Required<Pick<ImageProps, 'alt'>>;
export const ArticleCoverPhoto = ({
  style,
  ...rest
}: ArticleCoverPhotoProps) => <Image width={1} height="100%" borderRadius="8px" alt="Article Cover Photo" {...rest} style={{
  objectFit: 'cover',
  ...style
}} data-sentry-element="Image" data-sentry-component="ArticleCoverPhoto" data-sentry-source-file="index.tsx" />;